import { buildTranslate } from 'locales'
import React from 'react'
import { Button, Modal } from 'react-bootstrap-five'

const t = buildTranslate('thanx_campaigns.opportunity.upgrade_modal')

type Props = {
  show: boolean
  onHide: () => void
}

const UpgradeModal: React.FC<Props> = ({ show, onHide }) => {
  return (
    <Modal className="fs-unmask" show={show} onHide={onHide}>
      <Modal.Header closeButton className="border-none" />
      <Modal.Body className="padding-top-none margin-bottom-medium margin-left-large margin-right-large">
        <h5 className="text-center grey-90">{t('title')}</h5>
        <p className="body-text-2 text-center grey-60 padding-top-large">
          {t('secondary')}
        </p>
      </Modal.Body>
      <Modal.Footer className="text-center border-none">
        <Button
          variant="primary"
          size="lg"
          onClick={onHide}
          href="mailto:merchant.support@thanx.com"
          className="center-block"
        >
          {t('contact')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default UpgradeModal
